export default [
  'default',
  'animal',
  'bicycle',
  'boat',
  'bus',
  'car',
  'camper',
  'crane',
  'helicopter',
  'motorcycle',
  'person',
  'pickup',
  'plane',
  'ship',
  'shoppingbag',
  'tractor',
  'trailer',
  'trailer2',
  'train',
  'tram',
  'truck',
  'van',
  'scooter',
];